/* eslint-disable
   @typescript-eslint/no-explicit-any
*/
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ComponentRef,
    DestroyRef,
    ElementRef,
    HostBinding,
    OnDestroy,
    Type,
    ViewChild,
    ViewContainerRef,
    inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ScrollContainerService } from '@frontend/sports/common/core/utils/scroll-container';
import { TrackingService, TrackingType, trackingConstants } from '@frontend/sports/tracking/feature';
import { ReplaySubject, combineLatest, first, isObservable } from 'rxjs';

import { ModalRef } from '../common/modal-ref';
import { DialogSettings } from './modal-dialog.model';
import { OpenedModalsStorageService } from './opened-modals-storage.service';

@Component({
    selector: 'ms-modal-dialog',
    templateUrl: './modal-dialog.component.html',
    providers: [ScrollContainerService],
})
export class ModalDialogComponent implements AfterViewInit, OnDestroy {
    private trackingService = inject(TrackingService);
    private scrollContainer = inject(ScrollContainerService);
    private _elRef = inject(ElementRef);
    private cdr = inject(ChangeDetectorRef);
    private openedModalsStorage = inject(OpenedModalsStorageService);

    private destroyRef = inject(DestroyRef);

    @HostBinding('class') className = 'ds-scrollbar';

    @ViewChild('componentHost', { read: ViewContainerRef }) componentHost: ViewContainerRef;
    dialogSettings: DialogSettings = {};

    contentComponent: Type<any>;
    inputs: any;
    modalRef: ModalRef;

    private componentLoaded$ = new ReplaySubject<ComponentRef<any>>(1);

    ngAfterViewInit(): void {
        this.mountComponent();
        if (this.modalRef) {
            combineLatest([this.componentLoaded$, this.modalRef.newData$])
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(([componentRef, data]) => {
                    for (const [key, value] of Object.entries(data)) {
                        componentRef.setInput(key, value);
                    }
                    this.cdr.detectChanges();
                });
        }
        if (this.dialogSettings.tracking) {
            switch (this.dialogSettings.tracking.type) {
                case TrackingType.PageName:
                    this.trackingService.track(this.dialogSettings.tracking.name, this.dialogSettings.tracking.data || {});
                    break;
                case TrackingType.Referring:
                    this.trackingService.update({ [trackingConstants.PAGE_REFERRING_ACTION]: this.dialogSettings.tracking.name });
                    break;
            }
        }

        this.componentLoaded$.pipe(first()).subscribe(() => {
            const target = this._elRef.nativeElement.querySelector(this.dialogSettings.scrollTargetQuerySelector);
            if (target) {
                this.scrollContainer.setTarget(target);
            }
            this.openedModalsStorage.openedModal = this.modalRef;
        });
    }

    private mountComponent = () => {
        this.componentHost.clear();
        const componentRef = this.componentHost.createComponent(this.contentComponent);
        if (this.inputs) {
            Object.keys(this.inputs).forEach((key) => {
                componentRef.setInput(key, this.inputs[key]);
            });
            componentRef.changeDetectorRef.detectChanges();
        }

        if (componentRef.instance.componentLoaded && isObservable(componentRef.instance.componentLoaded)) {
            componentRef.instance.componentLoaded.pipe(first()).subscribe(() => this.componentLoaded$.next(componentRef));
        } else {
            this.componentLoaded$.next(componentRef);
        }
    };

    ngOnDestroy(): void {
        this.openedModalsStorage.removeCurrent(this.modalRef);
    }
}
